import React, { Component } from 'react'
import './Sidebar.css'
import Step from '../commons/Step'
import GroupsContext from '../../GroupsContext'
import ListGroups from '../modules/ListGroups'

class Sidebar extends Component {
  render () {
    return (
      <GroupsContext.Consumer>
        {(groups) => {
          if (groups.length > 0) {
            return (
              <div className={this.props.collapsed ? 'sidebar sidebar--collapsed' : 'sidebar'}>
                <div className='sidebar__container'>
                  <ListGroups groups={groups} collapsed={this.props.collapsed} />
                </div>
              </div>
            )
          }
          return (
            <div className='sidebar sidebar--empty'>
              <div className='sidebar__container'>
                <h2>Como participar</h2>
                <p>Te compartimos unos sencillos pasos para comenzar a quinielar con Stadium.</p>
                <Step value='1' />
                <h4>Crea o únete a un grupo</h4>
                <p>Crea y sé el administrador de un grupo o espera a que te agreguen a uno. ¿Cuentas con un código premium?, úsalo para entrar a un grupo privado.</p>
                <Step value='2' />
                <h4>Llena tu quiniela</h4>
                <p>Elige entre local, empate o visitante. Apúrate antes del cierre de la jornada.</p>
                <Step value='3' />
                <h4>Sigue tus resultados</h4>
                <p>Compite y descubre quien es el verdadero maestro ¡todos juegan!</p>
              </div>
            </div>
          )
        }}
      </GroupsContext.Consumer>
    )
  }
}

export default Sidebar
